module.exports = __webpack_public_path__ + "06ee852858bc9e9a24306ee117908e0f.MP3";